export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/pin-left.f1579cbf-49e5cc.svg";